<template>
  <div id="guest-info" class="guest-info-dropdown">
    <div class="header-bar">
      <h3 class="title">Nombres de voyageurs</h3>
      <button class="close-btn" @click="close()">
        <img src="../../images/Croix fermer.svg" v-set-alt />
      </button>
    </div>

    <div class="choice-number">
      <span>Adultes</span>
      <div class="counter">
        <button @click="decreaseAdults()">-</button>
        <span class="raleway-medi-p11">{{ adults }}</span>
        <button @click="increaseAdults()">+</button>
      </div>
    </div>

    <div class="choice-number">
      <span>Enfants</span>
      <div class="counter">
        <button @click="decreaseChilds()">-</button>
        <span class="raleway-medi-p11">{{ childs }}</span>
        <button @click="increaseChilds()">+</button>
      </div>
    </div>

    <div class="dropdown-age child-age-selector" v-if="childs">
      <p class="age-label">
        Quel est l’âge {{ formatName(childs) }} voyageant avec vous ?
      </p>
      <v-select
        v-for="(child, index) in childs"
        :key="`mobile-child-age-${index}`"
        class="select-item mb-1"
        placeholder="age"
        v-model="ageSelected[index]"
        :options="agesChoices"
        @input="selectAges(index, $event)"
      ></v-select>
    </div>

    <p v-if="showAgeError && childs && hasMissingChildAges()" class="text-danger age-error text-danger raleway-medi-p12 text-center">
      Merci de nous indiquer l'âge de vos enfants
    </p>

    <button class="confirm-btn" @click="close()">
      VALIDER
    </button>
  </div>
</template>
  
  <script>
  export default {
    name: "MobileGuestInfo",
    props: {
    initialAdults: {
      type: Number,
      default: 2
    },
    initialChilds: {
      type: Number,
      default: 0
    },
    initialChildAges: {
      type: Array,
      default: () => []
    },
    ageErrorTrigger: {
      type: Number,
      default: 0
    }
  },
    data() {
      return {
        rooms: 1,
        adults: this.initialAdults,
        childs: this.initialChilds,
        ageSelected: [...this.initialChildAges],
        agesChoices: [
          "1 an",
          "2 ans",
          "3 ans",
          "4 ans",
          "5 ans",
          "6 ans",
          "7 ans",
          "8 ans",
          "9 ans",
          "10 ans",
          "11 ans",
          "12 ans",
          "13 ans",
          "14 ans",
          "15 ans",
          "16 ans",
          "17 ans",
        ],
        showAgeError: false,
        isHydratingReservationState: true,
      };
    },
  
    methods: {
      close() {
        if (!this.persistReservationState()) {
          return;
        }

        this.$emit("updatedGuestState", {
          adults: this.adults,
          childs: this.childs,
          ageSelected: this.ageSelected
        });
        this.$emit("closed");
      },
      selectAges(index, value) {
        this.ageSelected[index] = value;
        this.showAgeError = this.hasMissingChildAges();
        this.$emit("ageSelected", [...this.ageSelected]);
        this.persistReservationState();
      },
      formatName(count) {
        return count > 1 ? "des enfants" : "de l'enfant";
      },
      hasMissingChildAges() {
        const childCount = Number.parseInt(this.childs, 10) || 0;
        if (childCount <= 0) return false;

        const selectedAges = this.ageSelected.slice(0, childCount);
        return selectedAges.length < childCount || selectedAges.some((age) => !String(age || '').trim());
      },
      normalizeChildAges(ages) {
        if (!Array.isArray(ages)) return [];
        return ages
          .map((age) => age?.toString?.().trim())
          .filter((age) => Boolean(age));
      },
      persistReservationState() {
        if (this.isHydratingReservationState) return true;

        if (this.childs > 0 && this.hasMissingChildAges()) {
          this.showAgeError = true;
          return false;
        }

        this.showAgeError = false;
        const state = JSON.parse(localStorage.getItem("reservationState")) || {};
        localStorage.setItem(
          "reservationState",
          JSON.stringify({
            ...state,
            adults: this.adults,
            childs: this.childs,
            children_ages: this.normalizeChildAges(this.ageSelected),
          })
        );
        return true;
      },
      decreaseRooms() {
        if (this.rooms > 0) {
          this.rooms -= 1;
          this.$emit("decreaseRooms", this.rooms);
        }
      },
      increaseRooms() {
        if (this.rooms < 9) {
          this.rooms += 1;
          this.$emit("increaseRooms", this.rooms);
        }
      },
      decreaseChilds() {
        if (this.childs > 0) {
          this.childs -= 1;
          this.showAgeError = this.hasMissingChildAges();
          this.$emit("decreaseChilds", this.childs);
        }
        this.persistReservationState();
      },
      increaseChilds() {
        if (this.childs < 30) {
          this.childs += 1;
          this.showAgeError = this.hasMissingChildAges();
          this.$emit("increaseChilds", this.childs);
        }
        this.persistReservationState();
      },
      decreaseAdults() {
        if (this.adults > 1) {
          this.adults -= 1;
          this.$emit("decreaseAdults", this.adults);
        }
        this.persistReservationState();
      },
      increaseAdults() {
        if (this.adults < 30) {
          this.adults += 1;
          this.$emit("increaseAdults", this.adults);
        }
        this.persistReservationState();
      },
    },
    mounted() {
      document.body.classList.add("scroll-lock");

      const reservationState = JSON.parse(localStorage.getItem("reservationState") || "{}");
      if (this.childs === 0 && reservationState.childs > 0) {
        this.childs = reservationState.childs;
      }
      if ((!Array.isArray(this.ageSelected) || this.ageSelected.length === 0) && Array.isArray(reservationState.children_ages)) {
        this.ageSelected = this.normalizeChildAges(reservationState.children_ages);
      }
      if (this.adults === 2 && reservationState.adults > 0) {
        this.adults = reservationState.adults;
      }

      this.$nextTick(() => {
        this.isHydratingReservationState = false;
      });

      this.stickyEl = document.querySelector('#homePhone .sticky');
      if (this.stickyEl) {
        this.stickyEl.style.display = 'none';

        this.scrollHandler = () => {
          if (this.stickyEl.style.display !== 'none') {
            this.stickyEl.style.display = 'none';
          }
        };
        window.addEventListener('scroll', this.scrollHandler);
      }
    },
    beforeDestroy() {
      document.body.classList.remove("scroll-lock");

      if (this.stickyEl) {
        this.stickyEl.style.display = '';
        window.removeEventListener('scroll', this.scrollHandler);
      }
    },
  watch: {
    childs(newCount) {
      if (newCount > this.ageSelected.length) {
        this.ageSelected.push(...new Array(newCount - this.ageSelected.length).fill(null));
      } else {
        this.ageSelected = this.ageSelected.slice(0, newCount);
      }
      this.showAgeError = this.hasMissingChildAges();
      this.persistReservationState();
    },
    ageErrorTrigger: {
      immediate: true,
      handler() {
        this.showAgeError = this.hasMissingChildAges();
      }
    }
  },
  };
  </script>
  
  <style scoped>
  #guest-info {
    position: fixed;
    top: 17vh;
    bottom: 0;
    left: 0;
    width: 100%;
    height: fit-content;
    background-color: #fff;
    z-index: 4001;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    animation: slideUp 0.3s ease-out;
    box-sizing: border-box;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0%);
    }
  }

  .header-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 20px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: 0;
  }

  .close-btn {
    position: absolute;
    right: 0;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .close-btn img {
    width: 24px;
    height: 24px;
  }

  .choice-number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 500;
  }
  .counter {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .counter button {
    width: 32px;
    height: 32px;
    border: 1px solid #000;
    background: none;
    font-size: 20px;
    line-height: 1;
    font-weight: bold;
    border-radius: 4px;
    cursor: pointer;
    color: #3b6152 !important;
  }
  .counter span {
    width: 20px;
    text-align: center;
  }
  .dropdown-age {
    margin-top: 10px;
  }

  .age-label {
    margin-bottom: 8px;
    font-size: 14px;
  }

  .age-error {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .confirm-btn {
    width: 100%;
    background-color: #3b6152;
    color: white;
    padding: 14px 0;
    font-size: 16px;
    font-weight: bold;
    border: none;
    margin-top: 20px;
    cursor: pointer;
    margin-bottom: 5vh;
  }
  </style>
  
